import { render } from "./IconCartComponent.vue?vue&type=template&id=38a5217b"
import script from "./IconCartComponent.vue?vue&type=script&lang=js"
export * from "./IconCartComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__